var React = require('react');

function Documents (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.29632 2.51852H6.22224V10.8141L12.1482 10.8148V6.37037H9.48252C8.82893 6.37037 8.29632 5.84138 8.29632 5.18754V2.51852ZM9.48252 5.18517H11.9367L9.48157 2.69256C9.48168 3.64893 9.48252 5.18517 9.48252 5.18517ZM10.963 13.7678C10.963 14.0941 10.6963 14.359 10.373 14.3595L3.25669 14.3695C2.93084 14.37 2.66669 14.1067 2.66669 13.7779V4.2962C2.66669 3.96897 2.9304 3.7037 3.2609 3.7037H5.03706V1.92583C5.03706 1.5986 5.29996 1.33333 5.63075 1.33333H9.50274C9.66731 1.33333 9.89522 1.42843 10.0111 1.5451L13.1229 4.67712C13.2392 4.79407 13.3334 5.02436 13.3334 5.1849V11.3952C13.3334 11.7227 13.0667 11.9887 12.7434 11.9891L10.963 11.9916V13.7678ZM5.62705 11.9992C5.30121 11.9996 5.03706 11.7363 5.03706 11.4075V4.8889H3.8578L3.85226 13.1852H9.7778V11.9933L5.62705 11.9992Z","fill":"#1C232B"}));
}

Documents.displayName = "Documents";

Documents.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Documents;

Documents.default = Documents;
